<mg-filter-form [filter]="filter" [formGroup]="form">
    <ng-container quickFilter>
        <mat-form-field>
            <mat-label>Title</mat-label>
            <input matInput placeholder="Search" formControlName="title" name="Title" />
            <button matSuffix mat-icon-button (click)="clear('title')" type="button" tabIndex="-1">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
    </ng-container>
    <!--    <ng-container expandedFilter>
    <mg-filter-form-section title="Algemeen">

			<mg-filter-form-row>
				<span>
                    <mat-form-field>
                        <input type="text" placeholder="Title" matInput formControlName="title">
                    </mat-form-field>
                </span>
				<span>
                    <mat-form-field>
                        <input type="text" placeholder="Message" matInput formControlName="message">
                    </mat-form-field>
                </span>
				<span>
                    <mat-form-field>
                        <input matInput [matDatepicker]="pickerDateMin" placeholder="Min Date" formControlName="dateMin">
                        <mat-datepicker-toggle matSuffix [for]="pickerDateMin"></mat-datepicker-toggle>
                        <mat-datepicker #pickerDateMin></mat-datepicker>
                    </mat-form-field>
                </span>,				<span>
                    <mat-form-field>
                        <input matInput [matDatepicker]="pickerDateMax" placeholder="Max Date" formControlName="dateMax">
                        <mat-datepicker-toggle matSuffix [for]="pickerDateMax"></mat-datepicker-toggle>
                        <mat-datepicker #pickerDateMax></mat-datepicker>
                    </mat-form-field>
                </span>
			</mg-filter-form-row>

			<mg-filter-form-row>
				<span>
                    <mat-form-field>
                        <input type="number" placeholder="Min Type" matInput formControlName="typeMin">
                    </mat-form-field>
                </span>,				<span>
                    <mat-form-field>
                        <input type="number" placeholder="Max Type" matInput formControlName="typeMax">
                    </mat-form-field>
                </span>
				<span>                
                    <mat-form-field>
                        <mg-autocomplete placeholder="Person" formControlName="person" [getData]="getPersonDataSource" (optionSelected)="search()"></mg-autocomplete>
                    </mat-form-field>
                </span>
				<span>
                    <mat-form-field>
                        <input matInput [matDatepicker]="pickerExpiringDateMin" placeholder="Min Expiring date" formControlName="expiringDateMin">
                        <mat-datepicker-toggle matSuffix [for]="pickerExpiringDateMin"></mat-datepicker-toggle>
                        <mat-datepicker #pickerExpiringDateMin></mat-datepicker>
                    </mat-form-field>
                </span>,				<span>
                    <mat-form-field>
                        <input matInput [matDatepicker]="pickerExpiringDateMax" placeholder="Max Expiring date" formControlName="expiringDateMax">
                        <mat-datepicker-toggle matSuffix [for]="pickerExpiringDateMax"></mat-datepicker-toggle>
                        <mat-datepicker #pickerExpiringDateMax></mat-datepicker>
                    </mat-form-field>
                </span>
			</mg-filter-form-row>

			<mg-filter-form-row>
				<span>                
                    <mat-form-field>
                        <mg-autocomplete placeholder="Customer subscription" formControlName="customerSubscription" [getData]="getCustomerSubscriptionDataSource" (optionSelected)="search()"></mg-autocomplete>
                    </mat-form-field>
                </span>
			</mg-filter-form-row>



    </mg-filter-form-section>
</ng-container>-->
</mg-filter-form>